
import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, AvisoSetor } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class AvisoSetorService extends BaseResourceService<AvisoSetor> {

  constructor(
    protected injector: Injector
  ) {
    super(`aviso-setors`, injector);
  }

}